/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



// Material Dashboard 2 PRO React TS Base Styles
import borders from "dashboard-template/assets/theme-dark/base/borders";
import boxShadows from "dashboard-template/assets/theme-dark/base/boxShadows";
import colors from "dashboard-template/assets/theme-dark/base/colors";

// Material Dashboard 2 PRO React TS Helper Functions
import boxShadow from "dashboard-template/assets/theme-dark/functions/boxShadow";

// types
type Types = any;

const { borderRadius } = borders;
const { xxl } = boxShadows;
const { dark, white, black } = colors;

const accordion: Types = {
  styleOverrides: {
    root: {
      backgroundColor: dark.main,
      color: white.main,
      boxShadow: boxShadow([0, 0], [15, 10], black.main, 0.1),
      "&:first-of-type": {
        borderTopLeftRadius: borderRadius.xl,
        borderTopRightRadius: borderRadius.xl,
      },

      "&:last-of-type": {
        borderBottomLeftRadius: borderRadius.xl,
        borderBottomRightRadius: borderRadius.xl,
      },
    },
  },
};

export const accordionSummary: Types = {
  styleOverrides: {
    expandIconWrapper: {
      color: white.main,
    },
  },
};

export default accordion;


